import { invokeApi } from "src/bi_lib/invokeApi";

export const createDelegate = async (data) => {
    const requestObj = {
        path: `/api/coach`,
        method: "POST",
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
        postData: data,
    };
    return invokeApi(requestObj);
};

export const listDelegates = async (page, limit, search) => {
    const requestObj = {
        path: `/api/coach/list?page=${page}&limit=${limit}`,
        method: "POST",
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
        postData: search,

    };
    return invokeApi(requestObj);
};

export const getDelegateDetail = async (id) => {
    const requestObj = {
        path: `/api/coach/${id}`,
        method: "GET",
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
    };
    return invokeApi(requestObj);
};

export const updateDelegate = async (id, data) => {
    const requestObj = {
        path: `/api/coach/${id}`,
        method: "PUT",
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
        postData: data,
    };
    return invokeApi(requestObj);
};
export const changeDelegatePassword = async (data) => {
    const requestObj = {
        path: `/api/coach/change_password_by_admin`,
        method: "POST",
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
        postData: data,
    };
    return invokeApi(requestObj);
};

export const deleteDelegate = async (id) => {
    const requestObj = {
        path: `/api/coach/${id}`,
        method: "DELETE",
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
    };
    return invokeApi(requestObj);
};
